export default __webpack_public_path__ + "static/media/credit-holder.0da33cc4.svg";